export default __webpack_public_path__ + "static/Collab-HeroSection-7d83ffdfc800e6bab85753798802b982.svg";